import ReactGA from "react-ga4";
import EventMapping from "./eventMapping";
import { EventTypes } from "./events";

const useEventTracker = (moduleName: string) => {
  const eventMapper = new EventMapping(moduleName);

  const trackEvent = (inputEvent: EventTypes, finalModuleName?: string) => {
    // console.log("input event in hook", inputEvent);

    try {
      const finalEvent = eventMapper.getEvent(inputEvent, finalModuleName);
      // console.log("final event in hook", finalEvent);
      ReactGA.event(finalEvent);
    } catch (error) {
      console.warn("Event tracking error:", error);
    }
  };

  const trackEventError = (
    inputEvent: EventTypes,
    eventLabel: string,
    finalModuleName?: string
  ) => {
    try {
      const finalEvent = eventMapper.getEventError(
        inputEvent,
        eventLabel,
        finalModuleName
      );
      // console.log('final error event',finalEvent);
      ReactGA.event(finalEvent);
    } catch (error) {
      console.warn("Event tracking error:", error);
    }
  };

  return { trackEvent, trackEventError };
};

export default useEventTracker;
